import React,{useState,useEffect, useRef} from 'react'

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { Print } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useAppData } from '../../../../../../context/AppDataContext';
import voucherServices from '../voucherServices';
import FinanceLayout from '../../../../../../layout/components/FinanceLayout';
import MonthlyDateSelect from '../../../../../../components/AppInput/MonthlyDateSelect';





const CellActions = (props) =>{
    
    const displayVoucherNo = props.data.voucherNo?props.data.voucherNo:"Draft-"+props.data.voucherType+"-"+props.data.id;

    return(

        

        <>
            {(props.data.voucherType === "Sale" || props.data.voucherType === "Purchase") &&
                <Link target="_blank" to={`/voucher/sale-purchase/details/${props.data.id}`}>{displayVoucherNo}</Link>
            }
            {(props.data.voucherType === "Payment" || props.data.voucherType === "Receipt") &&
                <Link target="_blank" to={`/voucher/payment-receipt/details/${props.data.id}`}>{displayVoucherNo}</Link>
            }
            {(props.data.voucherType === "Contra" || props.data.voucherType === "Journal") &&
                <Link target="_blank" to={`/voucher/contra-journal/details/${props.data.id}`}>{displayVoucherNo}</Link>
            }

            {(props.data.voucherType === "CreditNote" || props.data.voucherType === "DebitNote") &&
                <Link target="_blank" to={`/voucher/contra-journal/details/${props.data.id}`}>{displayVoucherNo}</Link>
            }

            {(props.data.voucherType === "Expense" ) &&
                <Link target="_blank" to={`/voucher/expense/details/${props.data.id}`}>{displayVoucherNo}</Link>
            }

            {(props.data.voucherType === "ChallanIn" || props.data.voucherType === "ChallanOut") &&
                <Link target="_blank" to={`/voucher/challan/details/${props.data.id}`}>{displayVoucherNo}</Link>
            }
            {/*

            <ProjectForm  callBack={props.callBack} data={props.data} />
            <ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog>
            */}
        </>
    )
}

function VoucherDashboardPage() {

    const gridRef = useRef();
    const {userDD,ledgerDD,getDDDataById} = useAppData();
    const [voucherList,setVoucherList] = useState();
    const [filter,setFilter] = useState(null);

    const [defaultColDef] = useState({
        floatingFilter: true,
        filterParams: {
          buttons: ['apply'],
        },
        resizable: true,
        width:120,
        filter:true,
        sortable: true,
        cellStyle: { 'textTransform': 'uppercase' },
    });


    const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
        let _columnDefs = [
            {field:"id",headerName: "ID"},
            {field:"voucherType",headerName: "Voucher Type",width:200},            
            {headerName:"Voucher #", width:250, valueGetter: params => params.data.voucherNo,
                cellRenderer: CellActions,
                cellRendererParams: {
                    callBack:getVoucherList,
                    //remove:remove
                },
            },   
            {headerName: "Ledger", width:250,
              valueGetter:params=>{
                return getDDDataById(ledgerDD,params.data.ledgerId)? getDDDataById(ledgerDD,params.data.ledgerId).label : "--";
              }
            },
            {headerName: "Created By", width:250,
              valueGetter:params=>{
                return getDDDataById(userDD,params.data.userId).label;
              }
            },
               
        ];
        setColumnDef(_columnDefs);
    }
    
    const onBtnExport = () => {
        gridRef.current.api.exportDataAsCsv("data.csv");
    };
    
    useEffect(()=>{    
        prepairColumnDef();
    },[]);

    const getVoucherList =() =>{
        voucherServices.getList(filter).then(res=>{
            setVoucherList(res.data);
        }).catch(error=>{

        })
    }

    useEffect(()=>{
        getVoucherList();
    },[filter])

    return (
        <FinanceLayout>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-md-12 my-2'>
                        <MonthlyDateSelect filter={filter} setFilter={setFilter} />  
                    </div>
                </div>
            
                <div className='row'>
                    <div className='col-md-12'>
                        <div className="ag-theme-alpine" style={{height: 600}}>
                            <AgGridReact
                                ref={gridRef}
                                rowData={voucherList}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                animateRows={true}
                                onGridReady={getVoucherList}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </FinanceLayout>
    )
}

export default VoucherDashboardPage